import React from 'react'
import { Styling } from './styled.js'
import Image from './Image'


export default function ImageImage({image1, image2, gallery}) {
    

    console.log(gallery)

    
    
    return (
        <Styling>
            <Image theImage={image1.localFile} gallery={gallery} />
            <Image theImage={image2.localFile} gallery={gallery} />
        </Styling>
    )
}
